import React, { useState, useEffect } from "react";

import classnames from "classnames";
import isNumber from "lodash/isNumber";
import Rheostat from "rheostat";


import { useSearchContext } from "components/store/source";
import {
  setPriceRange,
  setHighlightListings,
} from "components/store/source/actions/searchCriteriaActions";
import { Text } from "components/ui/source";

import { SearchPricingFilter } from "types/graphql";

import styles from "./PriceRangeFilter.module.scss";

export type PriceRangeFilterProps = {
  data?: Partial<SearchPricingFilter>;
  isDropdown?: boolean;
};

export function PriceRangeFilter({
  data: { options, selected },
  isDropdown = true,
}: PriceRangeFilterProps) {
  const {
    dispatch,
    criteria: { currencySymbol },
  } = useSearchContext();

  const [activeValues, setActiveValues] = useState(
    getValidValues(selected, options),
  );

  useEffect(() => {
    setActiveValues(getValidValues(selected, options));
  }, [options, selected]);

  const handleChange = ({ values }) => {
    dispatch(
      setPriceRange({
        priceMin: values[0],
        priceMax: values[1],
      }),
    );
    dispatch(setHighlightListings(false));
  };

  const handleValuesUpdated = ({ values }) => {
    setActiveValues({
      min: values[0],
      max: values[1],
    });
  };

  return (
    <div
      className={classnames(
        styles.container,
        isDropdown && styles["container--in-dropdown"],
      )}
    >
      <div className={styles.title}>
        <Text
          types={["caption1", "medium"]}
          translateKey="filters.priceFilters.dropdown_title"
        />
      </div>
      <Rheostat
        onChange={handleChange}
        onValuesUpdated={handleValuesUpdated}
        max={options.max}
        min={options.min}
        values={[activeValues.min, activeValues.max]}
      />
      <div className={styles.price_display}>
        <Text
          types={["caption1", "medium"]}
        >{`${currencySymbol}${activeValues.min} - ${currencySymbol}${activeValues.max}`}</Text>
      </div>
    </div>
  );
}

function getValidValues(selected, options) {
  return {
    min: isNumber(selected.min) ? selected.min : options.min,
    max: isNumber(selected.max) ? selected.max : options.max,
  };
}
